module.exports = __webpack_public_path__ + "img/gost-mode-feature.24f93a10.webp";